export const formatDate = (inputDate) => {
  if (!inputDate) return null;

  const date = new Date(inputDate);

  if (isNaN(date)) return null;

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};

export const removeExpiredLinks = (expireTime) => {
  const now = new Date().getTime();
  const expireAt = new Date(expireTime).getTime();


  if (expireAt > now) {
    const timeDiff = expireAt - now;

    // Calculate time left in days, hours, and minutes
    const daysLeft = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    const hoursLeft = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutesLeft = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));

    return {
      isValid: true,
      message: `Link is valid for ${daysLeft} days, ${hoursLeft} hours, and ${minutesLeft} minutes.`,
      daysLeft,
      hoursLeft,
      minutesLeft
    };
  } else {

    const timeDiff = now - expireAt;

    const daysAgo = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    const hoursAgo = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutesAgo = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));

    return {
      isValid: false,
      message: `Link expired ${daysAgo} days, ${hoursAgo} hours, and ${minutesAgo} minutes ago.`,
      daysAgo,
      hoursAgo,
      minutesAgo
    };
  }
};


export function formatDateHumanReadable(dateString, format) {
  const date = new Date(dateString);

  if (format === 'date') {
    const options = {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
      timeZone: 'UTC'
    };
    return date.toLocaleDateString('en-GB', options);
  } else if (format === 'time') {
    const months = ['January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'];

    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    hours = hours.toString().padStart(2, '0');

    return `${day} ${month} ${year} At ${hours}:${minutes}:${seconds} ${ampm}`;
  }

  return ''; // Fallback if format is neither 'date' nor 'time'
}


export function formatEpochHumanReadable(epoch, format) {
  if (!epoch) return '-'; // Handle null/undefined cases

  // Convert to number if it's a string
  epoch = typeof epoch === 'string' ? parseInt(epoch) : epoch;

  // Convert to milliseconds if epoch is in seconds
  if (epoch < 1e12) {
    epoch *= 1000;
  }

  const date = new Date(epoch);

  if (format === 'date') {
    const months = ['January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  }
  else if (format === 'time') {
    const months = ['January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'];

    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    hours = hours.toString().padStart(2, '0');

    return `${day} ${month} ${year} At ${hours}:${minutes}:${seconds} ${ampm}`;
  }

  return '-'; // Fallback
}

export function formatDateTime(dateInput) {
  if (!dateInput) return
  try {
 
    const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
    
    if (isNaN(date.getTime())) {
      throw new Error('Invalid date');
    }
     

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; 
    
    
    const formattedHours = String(hours).padStart(2, '0');
    
    return `${year}-${month}-${day} ${formattedHours}:${minutes} ${ampm}`;
  } catch (error) {
    console.error('Error formatting date:', error);
    return ''; 
  }
}